module.exports = __webpack_public_path__ + "static/media/listing-05.79eb3411.jpg";